module.exports = __webpack_public_path__ + "static/media/progresstick.9787bab1.svg";